// extracted by mini-css-extract-plugin
export default {"getInTouchCard":"ContactUs_getInTouchCard__H-evx"};